import React, { useEffect } from 'react';
import { UploadFile } from 'antd/es/upload/interface';
import { CustomImage } from './CustomImage';
import { StyledCustomUploadList } from './style';

interface CustomUploadListProps {
  fileList: UploadFile[];
  onRemove: (file: UploadFile) => void;
  onEdit: (file: UploadFile) => void;
  showActions?: boolean;
  aspectRatio?: number;
  selectedImageName?: string;
  setSelectedImageName?: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  selectable: boolean | undefined;
  showDefault?: boolean;
}

export const CustomUploadList: React.FC<CustomUploadListProps> = ({
  fileList,
  onRemove,
  onEdit,
  showActions = true,
  aspectRatio,
  selectedImageName,
  setSelectedImageName,
  selectable,
  showDefault,
}) => {
  useEffect(() => {
    if (!fileList) return;

    if (setSelectedImageName && selectable && fileList.length === 1) {
      setSelectedImageName(fileList[0].name);
    }
  }, [fileList, selectable, setSelectedImageName]);

  return (
    <StyledCustomUploadList className={'custom-upload-list-image-container'}>
      {fileList.map((file) => (
        <CustomImage
          aspectRatio={aspectRatio}
          key={file.uid}
          file={file}
          onEdit={onEdit}
          onRemove={onRemove}
          showActions={showActions}
          selectedImageName={selectedImageName}
          setSelectedImageName={setSelectedImageName}
          selectable={selectable}
          showDefault={showDefault}
        />
      ))}
    </StyledCustomUploadList>
  );
};
